export default __webpack_public_path__ + "static/media/playpause_icon_bold.f4004fce.svg";